export default "__VITE_ASSET__BfgrdLqo__"